module.exports = __webpack_public_path__ + "img/escudo-XVII-Leg-gris.13494aec.svg";